<template>
  <div class="fromStyle">
    <a-form :form="form" @submit="handleSubmit">
      <a-form-item
        label="岗位类型"
        :label-col="{ span: 5 }"
        :wrapper-col="{ span: 12 }"
      >
        <a-select placeholder="请选择岗位类型" @change="typeSelectChange">
          <a-select-option
            v-for="(item, i) in typeList"
            :key="i"
            :value="item.value"
            >{{ item.label }}</a-select-option
          >
        </a-select>
      </a-form-item>
      <a-form-item
        v-show="HideInRoleList"
        label="岗位名称"
        :label-col="{ span: 5 }"
        :wrapper-col="{ span: 12 }"
      >
        <a-select
          mode="multiple"
          showSearch
          optionFilterProp="children"
          v-decorator="[
            'role_id_list',
            { rules: [{ required: true, message: '请选择岗位名称!' }] }
          ]"
          placeholder="请选择岗位名称"
        >
          <a-select-option
            v-for="(item, i) in roleList"
            :key="i"
            :value="item.id"
            >{{ item.role_name }}</a-select-option
          >
        </a-select>
      </a-form-item>
      <a-form-item
        label="用户名称"
        :label-col="{ span: 5 }"
        :wrapper-col="{ span: 12 }"
      >
        <a-input
          v-decorator="[
            'user_name',
            { rules: [{ required: true, message: '请填写用户名称!' }] }
          ]"
        />
      </a-form-item>
      <a-form-item
        label="手机号码"
        :label-col="{ span: 5 }"
        :wrapper-col="{ span: 12 }"
      >
        <a-input
          v-decorator="[
            'phone',
            {
              rules: [{ required: true, message: '请输入您的手机号码!' }]
            }
          ]"
        >
          <a-select
            slot="addonBefore"
            v-decorator="['prefix', { initialValue: '86' }]"
          >
            <a-select-option value="86">+86</a-select-option>
            <a-select-option value="87">+87</a-select-option>
          </a-select>
        </a-input>
      </a-form-item>
      <a-form-item
        label="性别"
        :label-col="{ span: 5 }"
        :wrapper-col="{ span: 12 }"
      >
        <a-radio-group v-decorator="['gender']">
          <a-radio value="1">男</a-radio>
          <a-radio value="2">女</a-radio>
        </a-radio-group>
      </a-form-item>

      <a-form-item :wrapper-col="{ span: 12, offset: 5 }">
        <a-button type="primary" html-type="submit">提交</a-button>
      </a-form-item>
    </a-form>
  </div>
</template>

<script>
import axios from "axios";
export default {
  inject: ["reload"],
  data() {
    return {
      formLayout: "horizontal",
      form: this.$form.createForm(this),
      roleList: [],
      typeList: [
        {
          label: "公司内部",
          value: 1
        },
        {
          label: "客户",
          value: 3
        }
      ],
      HideInRoleList: false
    };
  },
  mounted() {},
  methods: {
    getRoleList(type) {
      const url = this.httpsBasic.url + this.httpsBasic.user + "User/roleList";
      const pramas = {
        token: window.localStorage.getItem("xnwfPcToken"),
        per_page: 100000,
        role_type: type
      };
      axios
        .post(url, pramas)
        .then(res => {
          // console.log(res);
          if (res.data.code == 200) {
            this.roleList = res.data.data.data;
          } else {
            this.$message.warning(res.data.message);
          }
        })
        .catch(err => {
          this.$message.error("服务器出错啦...");
        });
    },
    handleSubmit(e) {
      e.preventDefault();
      //   console.log(this.$store.state.token)
      this.form.validateFields((err, value) => {
        //  console.log(value)
        if (!err) {
          let url = this.httpsBasic.url + this.httpsBasic.user + "User/addUser";
          let pramas = {
            role_id_list: value.role_id_list,
            user_name: value.user_name,
            phone: value.phone,
            gender: value.gender,
            token: window.localStorage.getItem("xnwfPcToken")
          };
          if (pramas.gender == undefined) {
            delete pramas.gender;
          }
          axios
            .post(url, pramas)
            .then(res => {
              if (res.data.code == 200) {
                this.$message.success("提交成功");
                this.$emit("hideInAdd", false);
                this.form.resetFields();
              } else {
                this.$message.warning(res.data.message);
              }
            })
            .catch(err => {
              this.$message.error("服务器出错了...");
            });
        }
      });
    },
    typeSelectChange(value) {
      this.HideInRoleList = true;
      this.getRoleList(value);
      //  console.log(value);
      //   this.form.setFieldsValue({
      //     note: `Hi, ${value === "male" ? "man" : "lady"}!`
      //   });
    }
  }
};
</script>

<style lang="less" scoped>
.fromStyle {
  margin: 12% 4%;
}
</style>
